<template>
  <div class="message-input-wrapper">
    <textarea
      class="message-input"
      autofocus
      autocomplete="off"
      placeholder="請輸入訊息"
      v-model="newMessage"
      :disabled="!currentChatGroup"
      @keydown.enter="sendMessage"
      @keyup.enter="clearEmptyLine"
    ></textarea>
  </div>
</template>


<script>

export default {
  props: ['currentChatGroup'],
  data() {
    return {
      newMessage: ""
    };
  },
  created() {},

  methods: {
    sendMessage(event){
      if (!event.shiftKey) {
        var value = this.newMessage && this.newMessage.trim();
        this.newMessage = "";
        if (value === "") { return; }
        return eventHub.$emit('send-message', this.currentChatGroup, value);
      }
    },
    clearEmptyLine() {
      var value = this.newMessage && this.newMessage.trim();
      if (value === "") { return this.newMessage = ""; }
    }
  }
}
</script>


// WEBPACK FOOTER //
// app/javascript/packs/messenger/message_input.vue